import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../context/installation';
import { AllInvitationsQuery, AllInvitationsQueryVariables, Invitation } from '../../data-access/gql-types/graphql';
import { ALL_INVITATIONS } from '../../data-access/queries/invitations';

type UseInvitationsParams = {
  installationId: string;
  createdByUserId: string;
};

export const useInvitations = ({ installationId, createdByUserId }: UseInvitationsParams) => {
  const { skipLavvaFetch } = useInstallationContext();
  const { data, loading } = useQuery<AllInvitationsQuery, AllInvitationsQueryVariables>(ALL_INVITATIONS, {
    variables: {
      includeCreatedByMe: true,
      includeInvitedMe: true,
      installationId,
      createdByUserId,
    },
    fetchPolicy: 'network-only',
    skip: skipLavvaFetch || !installationId || !createdByUserId,
  });

  const invitations = useMemo(() => (data?.allInvitations as Invitation[]) || [], [data?.allInvitations]);

  return {
    invitations,
    loading,
  };
};
